class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = false;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    var requiredFields = this.querySelectorAll('[required]');
    requiredFields.forEach((input) => {
      input.addEventListener('keyup', () => {
        var errorFields = requiredFields.length;
        requiredFields.forEach((input2) => {
          if (input2.checkValidity()) {
            errorFields--;
          }
        });
        const submitButton = this.querySelector('[type="submit"]');
        if (errorFields == 0) {
          submitButton.removeAttribute('disabled');
        } else {
          submitButton.setAttribute('disabled', 'true');
        }
      });
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const submtiButton = this.querySelector('[type="submit"]');
    if (submtiButton.hasAttribute("disabled")) return;

    const url = new URL(window.location.href);
    const params = url.searchParams;
    if (params.has('key')) {
      this.removeExistingLineItems(params.get('key'))
      return;
    }
    this.addItemsToCart();
  }

  removeExistingLineItems(key) {
    this.getCart()
      .then((result) => {
        const parsedState = JSON.parse(result);
        if (parsedState.error) {
          this.addItemsToCart();
          return;
        }

        let updates = {};
        let quantity = 1;
        parsedState.items.forEach((item) => {
          if (item.key == key || item.parent_relationship?.parent_key == key) {
            quantity = item.quantity;
            updates[`${item.key}`] = 0;
          }
        });

        this.updateCart(updates)
        .then((response) => {
          this.addItemsToCart(quantity);
        });
      })
  }

  getCart() {
    return fetch(`${window.routes.cart_url}.json`)
      .then((res) => res.text())
  }

  updateCart(updates) {
    return fetch(`${window.routes.cart_update_url}.js`, {
      body: JSON.stringify({ updates }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((resp) => resp.json());
  }

  addItemsToCart(quantity = 1) {
    var addObj = {
      items: this.generateLineItems(quantity),
      sections: this.getSectionsToRender().map((section) => section.section),
    };

    fetch(`${window.routes.cart_add_url}.js`, {
      body: JSON.stringify(addObj),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        console.log('complete', response);
        window.location.href = `${window.Shopify.routes.root}cart`;
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  generateLineItems(quantity = 1) {
    var items = this.form.querySelectorAll("[name=id]");
    if (!items[0]) {
      console.log("generateLineItems: primary line item not found");
      return [];
    }

    var parentId = items[0].value;

    var propertyFields = this.querySelectorAll('[name^="global-properties"]');
    var properties = {};
    propertyFields.forEach(prop => {
      properties[`${prop.dataset.property}`] = prop.value;
    })

    var line_items = [];

    items.forEach((item) => {
      var lineProperties = structuredClone(properties);
      if (item.dataset?.productIndex) {
        lineProperties["_bundle_index"] = item.dataset?.productIndex;
      }
      if(item.dataset.lineItemText) {
        lineProperties["message"] = item.dataset.lineItemText;
      }
      let lineItem = {
        id: item.value,
        quantity: parseInt(quantity),
        properties: lineProperties
      };
      if (item.value !== parentId) {
        lineItem.parent_id = parentId;
      }
      line_items.push(lineItem);
    });
    /// Section to look up and add additional line items if needed

    return line_items;
  }

  connectedCallback() { }
}

function syncHeaderHeight() {
  const header = document.querySelector('#shopify-section-header'); // or your header selector
  if (!header) return;

  const h = header.getBoundingClientRect().height;
  document.documentElement.style.setProperty('--header-h', `${h}px`);
}

syncHeaderHeight();
window.addEventListener('resize', syncHeaderHeight);

// If the header content can change height dynamically (menus, banners, auth state, etc.)
const header = document.querySelector('#shopify-section-header');
if (header) {
  const ro = new ResizeObserver(syncHeaderHeight);
  ro.observe(header);
}

customElements.define("product-form", ProductForm);